module.exports = __webpack_public_path__ + "static/media/next-page-arrow.1e5d6098.png";